import { useState, type FormEvent } from 'react';
import { STATS } from '@/mocks/kanliao';

export default function Hero() {
  const [value, setValue] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setValue('');
  };

  return (
    <section id="featured" className="relative w-full overflow-hidden">
      {/* faint oversized editorial backdrop character */}
      <span
        aria-hidden
        className="pointer-events-none absolute -top-10 left-1/2 -translate-x-1/2 select-none font-heading text-[26rem] font-black leading-none text-foreground-950/[0.03]"
      >
        导
      </span>

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6 pt-6">
        {/* magazine issue meta row */}
        <div className="flex items-center justify-between border-b border-background-200 pb-3 text-[11px] uppercase tracking-[0.2em] text-foreground-500">
          <span>看料网址导航 · 今日已更新</span>
          <span className="hidden items-center gap-1 sm:flex">
            <i className="ri-record-circle-line text-accent-600" />
            在线收录
          </span>
          <span>VOL.2026 · 直达不迷路</span>
        </div>

        {/* masthead */}
        <div className="flex flex-col items-center text-center">
          <p className="mt-8 inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-xs font-medium text-secondary-800">
            <i className="ri-fire-line text-accent-600" />
            看料入口 · 持续收录 · 失效即补
          </p>

          <h1 className="mt-5 flex items-baseline justify-center font-heading text-[15vw] font-black leading-[0.92] tracking-tight text-foreground-950 sm:text-[6rem] md:text-[7.5rem]">
            看料
            <span className="ml-3 hidden h-[2.5rem] w-[2.5rem] rounded-md bg-primary-500 sm:block md:h-[3rem] md:w-[3rem]" />
          </h1>

          <p className="mt-4 font-heading text-xl font-medium tracking-wide text-foreground-700 md:text-2xl">
            热门站点，一键直达<span className="text-primary-600">不迷路</span>
          </p>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            这里是把散落的热门站点整理好的<span className="font-semibold text-foreground-900">地址汇总</span>：按影视、综艺动漫、直播、资讯、资源分类摆放，打开就能找到想看的内容，不用反复搜索——收藏这一个就够用了。
          </p>

          {/* quick direct search bar (appearance only) */}
          <form
            onSubmit={handleSubmit}
            className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:border sm:border-background-200 sm:bg-background-50 sm:p-1.5 sm:shadow-none"
          >
            <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-3 sm:flex-1 sm:border-0 sm:bg-transparent sm:px-3 sm:py-0">
              <i className="ri-search-line text-lg text-foreground-500" />
              <input
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="输入想看的关键词，直达对应分类…"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                aria-label="直达搜索"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:py-2.5"
            >
              一键直达
            </button>
          </form>

          <p className="mt-3 text-xs text-foreground-400">
            支持站名 / 分类 / 标签关键词检索
          </p>
        </div>

        {/* stats editorial strip */}
        <div className="mt-10 grid grid-cols-3 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200">
          {STATS.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1 bg-background-50 px-4 py-5">
              <span className="font-heading text-2xl font-black text-primary-700 md:text-3xl">{s.num}</span>
              <span className="text-xs text-foreground-600 md:text-sm">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}